import './bootstrap';
import '../css/frontend.scss';

import {createApp, h} from 'vue';
import {createInertiaApp, router} from '@inertiajs/vue3';
import {resolvePageComponent} from 'laravel-vite-plugin/inertia-helpers';
import {ZiggyVue} from '../../vendor/tightenco/ziggy';
import {i18nVue} from 'laravel-vue-i18n';
import {initTeamMembersSlider, initTestimonialsSlider} from './shortcode-initializers';

import {createStore} from 'vuex';

import {createPinia} from 'pinia';

const store = createStore();
const pinia = createPinia();

createInertiaApp({
    title: (title) => {
        // Return just the page title without app name suffix
        return title;
    },
    resolve: (name) => resolvePageComponent(`./Pages/Frontend/${name}.vue`, import.meta.glob('./Pages/Frontend/**/*.vue')),
    setup({ el, App, props, plugin }) {
        router.on('finish', () => {
            initTestimonialsSlider();
            initTeamMembersSlider();
        });

        const app = createApp({
            render: () => h(App, props),
            mounted() {
                initTestimonialsSlider();
                initTeamMembersSlider()
            }
        })
            .use(plugin)
            .use(ZiggyVue)
            .use(i18nVue, {
                resolve: async lang => {
                    const langs = import.meta.glob('../../lang/*.json');
                    return await langs[`../../lang/${lang}.json`]();
                }
            })
            .use(store)
            .use(pinia)
            .mount(el);

        return app;

    },
    progress: {
        delay: 0,
        color: '#4B5563',
        showSpinner: true,
    },
});
